import { inject, Injectable } from '@angular/core';
import { environment } from '../../../environments/environment';
import { HttpClient, HttpParams } from '@angular/common/http';
import { Observable } from 'rxjs';

@Injectable({
  providedIn: 'root',
})
export class MbqService {
  private baseUrl = environment.apiUrl;
  http = inject(HttpClient);
  constructor() {}

  getMbqList(storeId: string, page: number = 1, limit: number = 10) {
    // ✅ include pagination parameters in the query
    return this.http.get<any>(
      `${this.baseUrl}/replenishment/configs?storeId=${storeId}&page=${page}&limit=${limit}`,
    );
  }

  saveMbq(data: any) {
    return this.http.post<any>(`${this.baseUrl}/replenishment/configs`, data);
  }

  searchVariants(query: string, storeId: string) {
    return this.http.get<any[]>(
      `${this.baseUrl}/replenishment/configs/variant/search?query=${query}&storeId=${storeId}`,
    );
  }

  updateMbq(id: string, body: any) {
    return this.http.put(`${this.baseUrl}/replenishment/configs/${id}`, body);
  }

  getMbqDrafts(options?: {
    q?: string;
    status?: string;
    limit?: number;
    page?: number;
  }) {
    let params = new HttpParams();
    if (options?.q) params = params.set('q', options.q);
    if (options?.status) params = params.set('status', options.status);
    if (options?.limit) params = params.set('limit', options.limit);
    if (options?.page) params = params.set('page', options.page);

    return this.http.get(`${this.baseUrl}/mbq-draft`, { params });
  }

  getMbqDraftItems(
    draftId: string,
    options?: {
      q?: string;
      status?: string;
      limit?: number;
      page?: number;
    },
  ) {
    let params = new HttpParams();
    if (options?.q) params = params.set('q', options.q);
    if (options?.status) params = params.set('status', options.status);
    if (options?.limit) params = params.set('limit', options.limit);
    if (options?.page) params = params.set('page', options.page);

    return this.http.get(`${this.baseUrl}/mbq-draft/${draftId}/items`, {
      params,
    });
  }

  downloadMbqDraftPDF(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/pdf`, { responseType: 'blob' });
  }

  deleteMbqDraft(draftId: string) {
    return this.http.delete(`${this.baseUrl}/mbq-draft/${draftId}`);
  }

  downloadMbqDraft(id: string): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/${id}/pdf`, { responseType: 'blob' });
  }

  updateMbqDraftItem(draftId: string, itemId: string, body: any) {
    return this.http.patch(
      `${this.baseUrl}/mbq-draft/${draftId}/item/${itemId}`,
      body,
    );
  }

  addDraftItem(draftId: string, body: any) {
    return this.http.post(`${this.baseUrl}/mbq-draft/${draftId}/items`, body);
  }

  deletMbqItem(draftId: string, itemId: string) {
    return this.http.delete(
      `${this.baseUrl}/mbq-draft/${draftId}/item/${itemId}`,
    );
  }

  submitMbqDraft(draftId: string) {
    return this.http.post(`${this.baseUrl}/mbq-draft/${draftId}/submit`, {});
  }

  saveMbqData(draftId: string) {
    return this.http.patch(`${this.baseUrl}/mbq-draft/${draftId}/save`, {});
  }

  downloadTemplate(): Observable<Blob> {
    return this.http.get(`${this.baseUrl}/mbq-draft/download-template`, {
      responseType: 'blob',
    });
  }
}
